<template>
  <div class="login">
    <nav-bar @setLogin="setLogin" @setRegister="setRegister"></nav-bar>
    <div class="video-box">
      <video
        style="width: 100%; overflow: hidden"
        src="../../assets/video/video.mp4"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
        webkit-playsinline="true"
        playsinline="true"
      ></video>
    </div>
    <!-- 数据 -->
    <el-card :class="isMobile ? 'm-card' : 'p-card'">
      <el-table :data="tableData" style="width: 100%">
        <template slot="empty">
          <span style="color: #999;">{{ $t('暂无数据') }}</span>
        </template>
        <!-- 排名 -->
        <el-table-column prop="Rank" :label="$t('排名')" v-if="!isMobile" width="50">
        </el-table-column>
        <!-- 矿工 -->
        <el-table-column :label="$t('矿工')">
          <template slot-scope="scope">
            <span class="user-name">{{ scope.row.Miner }}</span>
          </template>
        </el-table-column>
        <!-- 市值 -->
        <el-table-column v-if="!isMobile" :label="$t('市值')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Market_Cap }}
          </template>
        </el-table-column>
        <!-- 价格 -->
        <el-table-column :label="$t('价格')">
          <template slot-scope="scope">
            <div class="table-price">
              <div class="price-left">
                <span class="doll">$</span>{{ scope.row.Price }}
              </div>
              <div class="price-right">
                <img v-if="scope.row.status == 1" src="../../assets/icon/up.png" />
                <img v-else src="../../assets/icon/down.png" />
                <span v-if="scope.row.status == 1" class="up">{{ scope.row.Fudu }}%</span>
                <span v-else class="down">{{ scope.row.Fudu }}%</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 移动端市值 -->
        <el-table-column v-if="isMobile" :label="$t('市值')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Market_Cap }}
          </template>
        </el-table-column>
        <!-- 成交量 -->
        <el-table-column v-if="!isMobile" :label="$t('成交量')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Volume }}
          </template>
        </el-table-column>
        <!-- 生产的PoW（24小时） -->
        <el-table-column v-if="!isMobile" :label="$t('生产的PoW（24小时）')">
          <template slot-scope="scope">
            <span>{{ scope.row.PoW_Produced }}</span>
          </template>
        </el-table-column>
        <!-- 哈希率/效率 -->
        <el-table-column v-if="!isMobile" :label="$t('哈希率')">
          <template slot-scope="scope">
            <span>{{ scope.row.Hashrate }}</span>
          </template>
        </el-table-column>
        <!-- 算法 -->
        <el-table-column v-if="!isMobile" :label="$t('算法')">
          <template slot-scope="scope">
            <span>{{ scope.row.Algorithm }}</span>
          </template>
        </el-table-column>
        <!-- 剩余供应（库存） -->
        <el-table-column v-if="!isMobile" :label="$t('剩余供应')">
          <template slot-scope="scope">
            <el-progress
              type="circle"
              :percentage="scope.row.Remaining_Supply"
              :stroke-width="15"
            ></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <footers></footers>
    <!-- 登录弹窗 -->
    <el-dialog :visible.sync="isShowLog" :width="isMobile ? '100%' : '35%'">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div :class="isMobile ? 'm-form' : 'p-form'">
          <p :class="isMobile ? 'm-title' : 'p-title'">{{ $t("登录") }}</p>
          <el-form-item prop="username">
            <template #label>
              <span class="label">{{ $t("电话号码") }}</span>
            </template>
            <el-input
              v-model="ruleForm.username"
              :placeholder="$t('请输入您的电话号码')"
              oninput ="value=value.replace(/[^a-zA-Z0-9]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <template #label>
              <span class="label">{{ $t("密码") }}</span>
            </template>
            <el-input
              v-model="ruleForm.password"
              type="password"
              :placeholder="$t('请输入密码')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="width: 100%; background-color: #002fff"
              >{{ $t("登录") }}</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 注册弹窗 -->
    <el-dialog :visible.sync="isShowReg" :width="isMobile ? '100%' : '35%'">
      <el-form
        :model="ruleFormReg"
        :rules="rulesd"
        ref="ruleFormReg"
        class="demo-ruleForm"
      >
        <div :class="isMobile ? 'm-form' : 'p-form'">
          <p :class="isMobile ? 'm-title' : 'p-title'">{{ $t("注册") }}</p>
          <el-form-item prop="tel">
            <template #label>
              <span class="label">{{ $t("电话号码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.tel"
              :placeholder="$t('请输入您的电话号码')"
              oninput ="value=value.replace(/[^a-zA-Z0-9]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="user_name">
            <template #label>
              <span class="label">{{ $t("姓名") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.user_name"
              :placeholder="$t('请输入您的姓名')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <template #label>
              <span class="label">{{ $t("密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.pwd"
              type="password"
              :placeholder="$t('请输入密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="confirm_password">
            <template #label>
              <span class="label">{{ $t("确认密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.confirm_password"
              type="password"
              :placeholder="$t('请确认密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="depositPwd">
            <template #label>
              <span class="label">{{ $t("提款密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.depositPwd"
              type="password"
              :placeholder="$t('请输入提款密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="invite_code">
            <template #label>
              <span class="label">{{ $t("邀请码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.invite_code"
              :placeholder="$t('请输入邀请码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <template #label>
              <span class="label">{{ $t("邮箱") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.email"
              :placeholder="$t('请输入您的邮箱')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitFormReg('ruleFormReg')"
              style="width: 100%; background-color: #002fff"
              >{{ $t("注册") }}</el-button
            >
          </el-form-item>
          <!-- 用户协议 -->
          <div class="agreement" style="display: flex;align-items: center;justify-content: center;">
            <el-checkbox v-model="checked"></el-checkbox>
            <div style="color: #002fff;margin-left: 10px;text-decoration: underline;" @click="getRich">{{ $t('用户协议') }}</div>
            <!-- 条款 -->
           <div style="cursor: pointer; color: #002fff;margin-left: 5px;text-decoration: underline;" @click="$router.push({path:'/rich', query: {id: 2}})">{{ $t("条款和条件") }}</div>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 用户协议弹窗 -->
    <el-dialog :visible.sync="isShowTC" :width="isMobile ? '100%' : '35%'" class="el-dialog1" :fullscreen="true">
      <div :class="isMobile ? 'm-title' : 'title'">
            <p>{{ title }}</p>
            <div class="line"></div>
        </div>
        <div class="content" v-html="content"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { login, register, unList, rich } from '../../api/index'
export default {
  data() {
    return {
      tableData: [],
      isShowLog: false,
      isShowReg: false,
      ruleForm: {
        username: "",
        password: "",
      }, // 表单数据
      rules: {
        username: [
          {
            required: true,
            message: this.$t('请输入您的电话号码'),
            trigger: 'blur'
          }
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' }
        ],
      }, // 校验规则
      ruleFormReg: {
        tel: '',
        user_name: '',
        pwd: '',
        confirm_password: '',
        invite_code: '',
        email: '',
        depositPwd: ''
      },
      rulesd: {
        tel: [
          {
            required: true,
            message: this.$t('请输入您的电话号码'),
            trigger: 'blur'
          }
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        user_name: [
          {
            required: true,
            message: this.$t('请输入您的姓名'),
            trigger: 'blur'
          }
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' }
        ],
        confirm_password: [
        { required: true, message: this.$t('请确认密码'), trigger: 'blur' }
        ],
        depositPwd: [
        { required: true, message: this.$t('请输入提款密码'), trigger: 'blur' }
        ],
        invite_code: [
            { required: true, message: this.$t('请输入邀请码'), trigger: 'blur' }
        ],
        email: [
            { required: true, message: this.$t('请输入您的邮箱'), trigger: 'blur' }
        ]
      }, // 校验规则
      checked: true, // 用户协议
      title: '',
      content: '',
      isShowTC: false
    };
  },
  computed: {
    // 映射 Vuex 的 getter 判断当前登录端
    ...mapGetters("device", ["isMobile"]),
    ...mapGetters("login", ["isLogin"]),
  },
  created() {
    this.getList()
    this.getUrl(window.location.href)
  },
  methods: {
    //用户协议
    // toxieyi(){
    //   const query = { id: 2 }
    //   this.$router.replace({
    //       path: '/rich',
    //       query: query,
    //     });
    // },
    getRich() {
        rich({id:2}).then(res=> {
            if (res.code == 0) {
                this.title = res.data.title
                this.content = res.data.content
                this.isShowTC = true
            }
        })
    },
    // 获取页面传参
    getUrl(url) {
        // console.log(new URL(url))
        // 获取参数部分
        let params = url.split('?')[1];
        // 将参数部分转换为对象
        let paramsObj = {};
        if (params) {
        let paramsArr = params.split('&');
        for (let i = 0; i < paramsArr.length; i++) {
        let param = paramsArr[i].split('=');
        paramsObj[param[0]] = param[1];
        }
        }
        // 获取指定参数的值
        let paramValue = paramsObj['code'];
        if (paramValue) {
          this.isShowReg = true
          this.ruleFormReg.invite_code = paramValue
          localStorage.removeItem('token')
          this.$store.dispatch('login/checkLoginType')
        }
      },
    // 获取数据列表
    getList() {
      unList().then(res=> {
        if (res.code == 0) {
          var result = res.data
          result.map(item=> {
            item.Remaining_Supply = Number(item.Remaining_Supply)
            item.status = Number(item.Fudu) > 0 ? 1 : 2
          })
          this.tableData = result
        }
      })
    },
    // 登录弹窗
    setLogin(data) {
      this.isShowLog = data;
    },
    // 注册弹窗
    setRegister(data) {
      this.isShowReg = data;
    },
    // 登录校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验成功去登陆
          login({tel:this.ruleForm.username,pwd: this.ruleForm.password}).then(res=> {
            if (res.code == 0) {
              this.$message({
                message: res.info,
                type: 'success'
              })
              localStorage.setItem('token',res.token)
              localStorage.setItem('info', JSON.stringify(res.userinfo))
              setTimeout(() => {
                this.$store.dispatch('login/checkLoginType')
                this.$store.dispatch('login/checkUserInfo')
                this.$router.push('/')
              }, 2000);
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 注册校验
    submitFormReg(formName) {
      this.$refs[formName].validate((valid) => {
        console.log('valid', valid)
        if (valid) {
          // 校验成功去登陆
          register(this.ruleFormReg).then(res=> {
            if (res.code == 0) {
              this.$message({
                message: res.info,
                type: 'success'
              })
              localStorage.setItem('token',res.token)
              localStorage.setItem('info', JSON.stringify(res.userinfo))
              setTimeout(() => {
                this.$store.dispatch('login/checkLoginType')
                this.$store.dispatch('login/checkUserInfo')
                this.$router.push('/')
              }, 2000);
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  overflow: hidden;
  .video-box {
    overflow: hidden;
    width: 100%;
  }

  .p-card {
    width: 70%;
    margin: 80px auto;
  }
  .m-card {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 70px;

    .user-name {
      font-size: 12px;
      color: rgb(77, 86, 219);
      font-weight: 600;
    }

    .table-price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  :deep(.el-progress-circle) {
    width: 50px !important;
    height: 50px !important;
  }

  :deep(.el-progress__text) {
    font-size: 12px !important;
  }

  :deep(.has-gutter) {
    .cell {
      font-size: 12px;
      color: #8fa6bf;
    }
  }

  .user-name {
    font-size: 16px;
    color: rgb(77, 86, 219);
    font-weight: 600;
  }

  .doll {
    color: #8fa6bf;
    margin-right: 4px;
  }

  .table-price {
    display: flex;
    align-items: center;

    .price-left {
      display: flex;
      align-items: center;
    }

    .price-right {
      display: flex;
      align-items: center;
    }

    img {
      width: 16px;
      height: 10px;
      margin: 0 3px;
    }

    .up {
      color: #27d9b1;
      font-size: 10px;
    }

    .down {
      color: #b63036;
      font-size: 10px;
    }
  }

  .p-title {
    font-size: 18px;
    color: #606266;
    font-weight: 600;
    // padding-left: 30px;
  }

  .m-title {
    font-size: 20px;
    color: #000;
    font-weight: 600;
    margin-top: 0;
  }

  .p-form {
    padding: 30px 30px 60px 30px;
  }

  .m-form {
    padding: 0 10px;
  }

  // 去掉el-form样式
  :deep(.el-dialog) {
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.8);
  }

  .el-dialog1{
    :deep(.el-dialog) {
      border-radius: 12px;
      background: #fff;
    }
  }


  .agreement {
    text-align: center;
  }
}
</style>
